angular.module('jv.Dashboard.Campaigns.Controller', []).controller('jv.Dashboard.Campaigns.Controller',
		[ '$scope', 'jvDashboardAjaxService', 'jvContextualLoadingService', '$rootScope', 'jvDashboardFactory', '$jobviteUrls','numberFilter', function($scope, jvDashboardAjaxService, jvContextualLoadingService, $rootScope, jvDashboardFactory, $jobviteUrls, numberFilter) {

			$scope.pageSize = 10;
			$scope.campaignsReturned = false;
			$scope.totalCount = 0;
			$scope.currentPage = 0;
			$scope.campaignType = 'EMAIL';
			$scope.createdBy ="Me";
			var initialPageNumber = 0;
			$scope.atsEnabled = atsEnabled;
			$scope.flags = {
				'showNoCampaignsError' : false
			};
			$scope.socialHeadings = [
			                        i18n['SOCIAL_TOTAL_MESSAGES'],
			                        i18n['SOCIAL_MESSAGES_WITH_LINKS'],
			                        i18n['TOTAL_UNIQUE_CLICKS'],
			                        i18n['SOCIAL_TN_AVG_CLICKS_PER_MS']
			                        ];

			$scope.webHeadings = [
			                        i18n['WEBPAGE_COMMON'],
			                        i18n['TOTAL_UNIQUE_CLICKS'],
			                        i18n['WEBPAGE_TN_CLICKTHROUGH_RATE']

			                        ];

			$scope.emailHeadings = [
			                        i18n['EMAILS_SENT'],
			                        i18n['OPEN_RATE'],
			                        i18n['TOTAL_UNIQUE_CLICKS'],
			                        i18n['EMAIL_CLICKTHROUGH_RATE']
			                        ];

			if($scope.atsEnabled){
				$scope.webHeadings.push(i18n['TOTAL_APPLIES']);
				$scope.emailHeadings.push(i18n['TOTAL_APPLIES']);
			}
			var widgetObject = $scope.widgetObject;
			jvContextualLoadingService.show($scope.widgetObject.widgetId);
			$scope.refreshTimestamp = true;

			$rootScope.$on('REFRESH_WIDGET', function(event, widgetData) {
				if (widgetData && ($scope.widgetObject.widgetId === widgetData.widgetId)) {
					$scope.refreshWidget();
				}
			});
			function getWidgetSettings() {
				var settingsInfo = $scope.widgetObject.userWidgetSettings.widgetSetting;
				if($scope.widgetObject && $scope.widgetObject.title.trim() === ""){
					$scope.widgetObject.title = i18n['DASHBOARD_WIDGET_CAMPAIGNS'];
				}
				angular.forEach(settingsInfo, function(settingInfo, index) {
					var values;
					if (settingInfo && settingInfo.userValues) {
						values = settingInfo.userValues;
					} else if (settingInfo && settingInfo.settings && settingInfo.settings.defaultValues) {
						values = settingInfo.settings.defaultValues;
					}

					if (values) {
						if (values[0] && angular.isObject(values[0].label) && values[0].EId) {
							values[0].value = angular.copy(values[0].EId);
							if (values[0].label.name) {
								values[0].label = angular.copy(values[0].label.name);
							}
							/*
							 * The API for fetching the list of hiring managers
							 * has the name returned as fullName. We need this
							 * for the hiring manager filter in settings
							 */
							else if (values[0].label.fullName) {
								values[0].label = angular.copy(values[0].label.fullName);
							}
							delete values[0].EId;
						} else if (values[0].label && values[0].label.name) {
							// filters with label and no EId property
							// Eg: SourceType
							// posting type has index attribute. Check
							// for undefined as 0 can be a value
							if ((values[0].label.index != undefined) && (values[0].label.index !== null)) {
								values[0].index = angular.copy(values[0].label.index);
							}
							values[0].value = angular.copy(values[0].label.name);
							values[0].label = angular.copy(values[0].label.name);
						}
						// Making sure UI doesnt make a call with all
						// filter
						if ($.isEmptyObject(values[0].label)) {
							values[0].label = '';
							values[0].value = null;
						}
						switch (settingInfo.settings.name) {
						case "CampaignType":
							$scope.campaignType = values[0].value;
							break;
						case "CreatedBy":
						    $scope.createdBy = values[0].value;
						default:
							break;
						}
					}
				});
			}

			$scope.refreshWidget = function() {
				$scope.refreshTimestamp = false;
				getWidgetSettings();
				$scope.fetchPage(0);
			};

			$scope.fetchPage = function(pageNumber) {
				// Hide widget
				jvContextualLoadingService.show($scope.widgetObject.widgetId);
				$scope.getCampaigns(pageNumber);
			}

			$scope.renderPage = function() {
				// Show widget
				jvContextualLoadingService.hide($scope.widgetObject.widgetId);
				// Refresh time stamp
				$scope.refreshTimestamp = true;
			};

			$scope.getCampaigns = function(page) {
				$scope.currentPage = page;
				// prepares the data for rendering in the grid.
				var massageData = function(results) {
					$scope.campaigns = null;
					if(results && results.resultList && results.analytics && results.resultList.length > 0 && results.analytics.length > 0) {
						$scope.campaigns = results.resultList;
						for(var i=0; i < results.analytics.length ; i++) {
							$scope.campaigns[i].analytics = results.analytics[i];
							if($scope.campaigns[i].analytics && $scope.campaigns[i].analytics.totalClicks && $scope.campaigns[i].analytics.views) {
								$scope.campaigns[i].analytics.clickthroughRates = '' + (numberFilter($scope.campaigns[i].analytics.totalClicks * 100 / $scope.campaigns[i].analytics.views, 2) || '0.0') + '%';
							}
						}
					}
					$scope.campaignsReturned = true;
				};
				var _callback = function(results) {
					massageData(results);
					$scope.totalCount = results.resultCount;
					$scope.renderPage();
				};

				var args = {
					page : $scope.currentPage,
					type: $scope.campaignType.toUpperCase() ,
					createdBy : $scope.createdBy.toUpperCase(),
					maxResults: $scope.pageSize
				};

				if ($scope.refresh || jvDashboardFactory.isNewlyAddedWidget($scope.widgetObject)) {
					args.refresh = true;
				}
				jvDashboardAjaxService.getCampaigns(args, _callback);
			};
			$scope.refreshWidget();
		}]);
